const ROOT_SELECTOR = '[data-trust-claims-hero]';

function dateInTimeZone(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

  return new Date(Date.UTC(
    Number(values.year),
    Number(values.month) - 1,
    Number(values.day),
    12
  ));
}

export function addBusinessDays(date, businessDays) {
  const result = new Date(date.getTime());
  const daysToAdd = Math.max(0, Math.floor(Number(businessDays) || 0));
  let addedDays = 0;

  while (addedDays < daysToAdd) {
    result.setUTCDate(result.getUTCDate() + 1);
    const dayOfWeek = result.getUTCDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      addedDays += 1;
    }
  }

  return result;
}

export function calculateShipByDate(now, businessDays, timeZone = 'America/New_York') {
  return addBusinessDays(dateInTimeZone(now, timeZone), businessDays);
}

export function formatShipByDate(date) {
  const day = date.getUTCDate();
  const lastTwoDigits = day % 100;
  const suffix = lastTwoDigits >= 11 && lastTwoDigits <= 13
    ? 'TH'
    : ({ 1: 'ST', 2: 'ND', 3: 'RD' }[day % 10] || 'TH');
  const month = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    timeZone: 'UTC'
  }).format(date).toUpperCase();

  return `${month} ${day}${suffix}`;
}

export function initTrustClaimsHero(root = document, now = new Date()) {
  const sections = [];

  if (root.matches?.(ROOT_SELECTOR)) {
    sections.push(root);
  }
  sections.push(...root.querySelectorAll(ROOT_SELECTOR));

  sections.forEach((section) => {
    const dateTarget = section.querySelector('[data-ship-by-date]');
    if (!dateTarget) return;

    const businessDays = Number.parseInt(section.dataset.businessDays, 10) || 3;
    const timeZone = section.dataset.timeZone || 'America/New_York';
    const shipByDate = calculateShipByDate(now, businessDays, timeZone);

    dateTarget.textContent = formatShipByDate(shipByDate);
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTrustClaimsHero(), { once: true });
  } else {
    initTrustClaimsHero();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTrustClaimsHero(event.target);
  });
}
